import { object, string, boolean, date, array } from 'yup';

const advancedFieldsSchema = object({
  id: string(),
  label: string().required(),
  variable: string().required(),
  name: string().required(),
  type: string().required(),
  disabled: boolean().default(false),
  category: string().required(),
  options: array().of(string()).optional(),
  prompt: string().optional().nullable(),
  is_general: boolean().default(true),
  is_computed: boolean().default(false),

  created_on: date().default(() => new Date()),
  updated_on: date().required(),
});

export default advancedFieldsSchema;
